import React from 'react';
import { ChangeRequestParticipantInfo } from '@/types';
import { NoResultsCard } from '@/components/Cards';
import { ChangeRequestParticipantListItemProps } from '.';
import ChangeRequestParticipantListItem from './ChangeRequestParticipantListItem';
import { Trans } from '@lingui/react/macro';

// const ReadyStatusIndicator: React.FC<{ value: boolean }> = ({ value }) => {
//     return (
//         <Indicator color={value ? 'success' : 'warning'}>
//             {value ? <Trans>Ready to send</Trans> : <Trans>In progress</Trans>}
//         </Indicator>
//     );
// };

type ChangeRequestParticipantListProps = Omit<ChangeRequestParticipantListItemProps, 'participant'> & {
    participants: ChangeRequestParticipantInfo[];
};

const ChangeRequestParticipantList: React.FC<ChangeRequestParticipantListProps> = ({ participants, ...rest }) => {
    return (
        <>
            {participants.map((participant) => (
                <ChangeRequestParticipantListItem key={participant.userId} participant={participant} {...rest} />
            ))}

            {participants.length === 0 && (
                <NoResultsCard>
                    <Trans>There are no participants added to this change requests yet.</Trans>
                </NoResultsCard>
            )}
        </>
    );
};

export default ChangeRequestParticipantList;